/**
 * Card Selectors
 */

import { getUIState } from '../../../../redux/selectors/ui';
import { getTrackFromProps } from '../../../../utils/track';

import { createSelector } from 'reselect';

export const makeIsCardSelected = () => {
  return createSelector(
    [getUIState, getTrackFromProps],
    ({ trackDetails }, track) => {
      return !!trackDetails && !!track
        && trackDetails.visible
        && !!trackDetails.trackInfo
        && trackDetails.trackInfo.id === track.id;
    },
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/media/Card/selectors.tsx